import {View} from 'MWC';
import tpl from '../templates/not-found';

export default class extends View {
    template = tpl;
}
